import React from 'react';
import { StyledGrid } from './grid.styled';
var Grid = function Grid(_ref) {
    var itemsPerRow = _ref.itemsPerRow, children = _ref.children, className = _ref.className;
    return /*#__PURE__*/ React.createElement(StyledGrid, {
        className: className || '',
        itemsPerRow: itemsPerRow || 3
    }, children);
};
export default Grid;
